import Vue from 'vue';
import App from './App.vue';
import router from './router';
import { DeviceFingerprint } from './helpers/fingerprint';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { store } from './store/index';
import host from './store/host';
import './assets/css/global.css';
import './assets/css/themes.css';

import secureImg from './helpers/secure-img';

// Глобально регистрируем директиву одной чистой строкой
Vue.directive('secure-img', secureImg);

import Vuex from 'vuex';
Vue.use(Vuex);

import VueResource from 'vue-resource';
Vue.use(VueResource);

// Создаем шину событий для вызова модалки капчи из интерцептора
if (!Vue.prototype.$captchaBus) {
  Vue.prototype.$captchaBus = new Vue();
}

import Spinner from './components/Spinner.vue';
Vue.component('spinner', Spinner);

import Toggle from './components/Toggle.vue';
Vue.component('Toggle', Toggle);

import DropDownBox from './components/DropDownBox.vue';
Vue.component('DropDownBox', DropDownBox);

import Multiselect from './components/Multiselect.vue';
Vue.component('Multiselect', Multiselect);

import AlertLabel from './components/alert-label.vue';
Vue.component('AlertLabel', AlertLabel);

import DatePickerBox from './components/DatePickerBox.vue';
Vue.component('DatePickerBox', DatePickerBox);

import TextBox from './components/TextBox.vue';
Vue.component('TextBox', TextBox);

import ExpandableText from './components/ExpandableText.vue';
Vue.component('ExpandableText', ExpandableText);

import ClickableCaptcha from './components/Captcha/ClickableCaptcha.vue';
Vue.component('ClickableCaptcha', ClickableCaptcha);

import CookieBanner from './components/CookieBanner.vue';
Vue.component('CookieBanner', CookieBanner);

import UserRegNotice from './components/IdentityForms/UserRegNotice.vue';
Vue.component('UserRegNotice', UserRegNotice);

import SiteLogo from './components/SiteLogo.vue';
Vue.component('SiteLogo', SiteLogo);

import AppFooter from './components/AppFooter.vue';
Vue.component('AppFooter', AppFooter);

import ErrorAlert from './components/ErrorAlert.vue';
Vue.component('ErrorAlert', ErrorAlert);

import AvatarCircle from './components/AvatarCircle.vue';
Vue.component('AvatarCircle', AvatarCircle);

import CircleCounter from './components/CircleCounter.vue';
Vue.component('CircleCounter', CircleCounter);
//

//#region иконки

import StopwatchIcon from './components/icons/StopwatchIcon.vue';
Vue.component('StopwatchIcon', StopwatchIcon);

import WebIcon from './components/icons/WebIcon.vue';
Vue.component('WebIcon', WebIcon);

import PaperPlaneIcon from './components/icons/PaperPlaneIcon.vue';
Vue.component('PaperPlaneIcon', PaperPlaneIcon);

import UsersIcon from './components/icons/UsersIcon.vue';
Vue.component('UsersIcon', UsersIcon);

import UserProfileIcon from './components/icons/UserProfileIcon.vue';
Vue.component('UserProfileIcon', UserProfileIcon);

import NewsPostsIcon from './components/icons/NewsPostsIcon.vue';
Vue.component('NewsPostsIcon', NewsPostsIcon);

import SettingsIcon from './components/icons/SettingsIcon.vue';
Vue.component('SettingsIcon', SettingsIcon);

import RejectedIcon from './components/icons/RejectedIcon.vue';
Vue.component('RejectedIcon', RejectedIcon);

import AutoModeratedIcon from './components/icons/AutoModeratedIcon.vue';
Vue.component('AutoModeratedIcon', AutoModeratedIcon);

import ArrowLeftIcon from './components/icons/ArrowLeftIcon.vue';
Vue.component('ArrowLeftIcon', ArrowLeftIcon);

import WarningIcon from './components/icons/WarningIcon.vue';
Vue.component('WarningIcon', WarningIcon);

import LayersIcon from './components/icons/LayersIcon.vue';
Vue.component('LayersIcon', LayersIcon);

import TelegramIcon from './components/icons/TelegramIcon.vue';
Vue.component('TelegramIcon', TelegramIcon);

import NewsSourcesIcon from './components/icons/NewsSourcesIcon.vue';
Vue.component('NewsSourcesIcon', NewsSourcesIcon);

import BarsChartIcon from './components/icons/BarsChartIcon.vue';
Vue.component('BarsChartIcon', BarsChartIcon);

import AppIcon from './components/icons/AppIcon.vue';
Vue.component('AppIcon', AppIcon);

import CalendarIcon from './components/icons/CalendarIcon.vue';
Vue.component('CalendarIcon', CalendarIcon);

import GeoMarkerIcon from './components/icons/GeoMarkerIcon.vue';
Vue.component('GeoMarkerIcon', GeoMarkerIcon);

import DollarCircleIcon from './components/icons/DollarCircleIcon.vue';
Vue.component('DollarCircleIcon', DollarCircleIcon);

//#endregion иконки

Vue.prototype.$host = host;

export const eventBus = new Vue();
Vue.prototype.$eventBus = eventBus;
Vue.config.productionTip = false;


// Инициализация Vuex хранилища
const commonStore = new Vuex.Store({
  state: { $isConnected: false },
  mutations: { 
    update$isConnected: function(state, value) { state.$isConnected = value; } 
  }
});

Vue.mixin({
  computed: {
    $isConnected: {
      get: function () { return commonStore.state.$isConnected },
      set: function(value) { return commonStore.commit('update$isConnected', value); }
    }
  }
});

Vue.prototype.$commonStore = commonStore;



//#region @microsoft/signalr

// https://www.npmjs.com/package/@microsoft/signalr
import * as signalR from "@microsoft/signalr";

const connection = 
  new signalR.HubConnectionBuilder()
  .withUrl(`${host.ws}/AppEventHub`,
  {
    transport: signalR.HttpTransportType.WebSockets,
    accessTokenFactory: () => store.state.token,
    logger: signalR.LogLevel.None,
    skipNegotiation: true
  })
  // Включаем встроенное переподключение: первые 3 попытки мгновенно (0 сек), затем каждые 2 секунды
  .withAutomaticReconnect([0, 0, 0, 2000, 2000]) 
  .configureLogging(signalR.LogLevel.Information)
  .build();

Vue.prototype.$connection = connection;

connection.on('Logout', function() {
  store.dispatch('logout');
});

// Флаг для предотвращения одновременных параллельных вызовов start
let isStarting = false;

async function startSignalR() {
  if (isStarting) return;
  
  // Проверяем, нужно ли вообще запускать (подключаемся только если Disconnected)
  if (connection.state !== signalR.HubConnectionState.Disconnected) {
    updateConnectionState();
    return;
  }

  isStarting = true;
  eventBus.$emit('disconnected');

  commonStore.state.$isConnected = connection.state == signalR.HubConnectionState.Connected;
  let restart = false;

  try {
    if (store.getters.isAuthenticated) {
      await connection.start()
      updateConnectionState();
      eventBus.$emit('connected');
    } else {
      restart = true;
    }
  } catch {
    restart = true;
  } finally {
    isStarting = false;
    if (restart) {
       // Вместо бесконечной рекурсии — контролируемый таймаут
      setTimeout(() => {
        isStarting = false;
        startSignalR();
      }, 2000); // 2 секунды паузы в случае жесткой ошибки сети
    }
  }
}

// Функция обновления состояния в Vuex
function updateConnectionState() {
  const isConnected = connection.state === signalR.HubConnectionState.Connected;
  commonStore.commit('update$isConnected', isConnected);
}

// Отслеживание встроенных событий автоматического переподключения SignalR
connection.onreconnecting(() => {
  commonStore.commit('update$isConnected', false);
  eventBus.$emit('disconnected');
});

connection.onreconnected(() => {
  commonStore.commit('update$isConnected', true);
  eventBus.$emit('connected');
});

connection.onclose(async () => {
  updateConnectionState();
  await startSignalR();
});

// --- МАГИЯ ДЛЯ МОБИЛЬНЫХ УСТРОЙСТВ ---
// Принудительно будим SignalR, когда вкладку открывают или снимают блок экрана
function forceWakeUp() {
  // Если соединение "зависло" или разорвано — пинаем его
  if (connection.state === signalR.HubConnectionState.Disconnected) {
    startSignalR();
  } else if (connection.state === signalR.HubConnectionState.Connected) {
    // Быстрая проверка: жив ли сокет. Отправляем пустой пинг, если нужно удостовериться
    updateConnectionState();
  }
}

// Триггер на возврат пользователя во вкладку (снятие с блокировки)
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') {
    forceWakeUp();
  }
});

// Триггер на фокус окна браузера
window.addEventListener('focus', () => {
  forceWakeUp();
});

// Первоначальный старт
startSignalR();
//#endregion


// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);

// We listen to the resize event
window.addEventListener('resize', async() => {
  // We execute the same script as before
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  await store.dispatch('detectDevicePlatform');
});

// window.addEventListener('focus', async() => {
//   // console.log('window got focus');
//   await checkSignalRConnection();
// });

window.matchMedia('(prefers-color-scheme: dark)')
  .addEventListener('change', async(event) => {
    const newColorScheme = event.matches ? "dark" : "light";
      if (store.state.systemSetting.theme == 'auto') {
        store.dispatch('applyTheme', newColorScheme);
      }
  });

await store.dispatch('detectDevicePlatform');
await store.dispatch('loadSettings');

const DEFAULT_TITLE = '';

router.beforeEach((to, from, next) => {
  // console.log(to);
  // console.log(from);
  window.scrollTo(0, 0);
  document.title = to.meta.title || DEFAULT_TITLE;
  if (to.meta.auth && !store.getters.isAuthenticated) {
    if (from.path === '/login') {
      // отменяем переход и остаёмся на той же странице
      next(false);
    } else {
      next('/login');
    }
  } else if (to.path === '/logout') {
    store.dispatch('logout');
  } else {
    // console.log("router.beforeEach: else");
    // eslint-disable-next-line
    if (to.path === '/login' && store.getters.isAuthenticated) {
      next(from.path);
    } else {
      next();
    }
  }
});

// Vue.http.interceptors.push((request, next) => {
//   // 1. СИНХРОННАЯ СБОРКА ВСЕХ ЗАГОЛОВКОВ (Теперь vue-resource не проскочит мимо)

//   // А) Токен авторизации
//   if (store.getters.isAuthenticated) {
//     request.headers.set('Authorization', `Bearer ${store.state.token}`);
//   }
//   request.headers.set('Accept', 'application/json');

//   // Б) Генерация фингерпринта устройства
//   let deviceId = 'fallback-device-id';
//   // Безопасный сбор фингерпринта
//   try {
//     deviceId = DeviceFingerprint.generateIdSync();
//   } catch (e) {
//     console.error("Ошибка сбора Fingerprint, использован fallback:", e);
//   }
//   request.headers.set('X-Device-ID', deviceId);

//   // В) Данные капчи из localStorage
//   try {
//     const pendingCaptcha = JSON.parse(localStorage.getItem('pending_captcha') || 'null');
//     if (pendingCaptcha && pendingCaptcha.value) {
//       request.headers.set('X-Captcha-Id', pendingCaptcha.id);
//       request.headers.set('X-Captcha-Value', pendingCaptcha.value);
//     }
//   } catch (e) {
//     localStorage.removeItem('pending_captcha');
//   }

//   // 2. ОБРАБОТКА ОТВЕТА СЕРВЕРА
//   next((response) => {
//     // console.log('status: ' + response.status);
//     // Если запрос прошел успешно — очищаем временный кэш капчи
//     if (response.ok) {
//       localStorage.removeItem('pending_captcha');
//       return response;
//     }

//     // А) ПЕРЕХВАТ КАПЧИ (Статус 423)
//     if (response.status === 423) {
//       // console.log('handle 423');
//       const serverData = response.body; // Объект { Message, Captcha: { CaptchaId, Image... } }

//       if (serverData && serverData.captcha) {
//         localStorage.setItem('pending_captcha', JSON.stringify({
//           id: serverData.captcha.captchaId,
//           value: ''
//         }));

//         // Создаем промис ожидания ввода капчи
//         const retryPromise = new Promise((resolve) => {
//           // console.log('call show-captcha');
//           Vue.prototype.$captchaBus.$emit('show-captcha', {
//             captcha: serverData.captcha,
//             onResolve: async (userValue) => {
//               // Пользователь ввел ответ: обновляем данные в кэше и заголовках
//               const pending = JSON.parse(localStorage.getItem('pending_captcha'));
//               pending.value = userValue;
//               localStorage.setItem('pending_captcha', JSON.stringify(pending));
              
//               request.headers.set('X-Captcha-Value', userValue);
//               request.headers.set('X-Captcha-Id', pending.id);
//               // request.headers.set('X-Captcha-Id', serverData.Captcha.captchaId);

//               // Повторяем оригинальный запрос
//               const retryResponse = await Vue.http(request);
//               resolve(retryResponse);
//             }
//           });
//         });

//         // Возвращаем промис, приостанавливая выполнение кода в компоненте
//         return retryPromise;
//       }
//     }

//     // Б) ВАША ИСХОДНАЯ ЛОГИКА ОБРАБОТКИ ОШИБОК
//     else if (response.status === 401) {
//       store.dispatch('logout');
//     } else if (response.status === 403) {
//       // toastr.error('Нет доступа');
//     } else if (response.status >= 400) {
//       // Статус 423 сюда больше не попадет, так как мы обработали его выше
//       if (response.body && response.body.message) {
//         console.log(`${response.status}: ${response.body.message}`);
//       } else {
//         console.log(`${response.status}: No response or server connection`);
//       }
//     }
//   });
// });


// для обработки 401 и обновления токена

// Переменные для управления очередью обновления токенов
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

// *******************

// Переменная для хранения ID (изначально пустая)
let visitorId = '';

Vue.http.interceptors.push(function(request, next) {
  // 1. Настройка заголовков (Синхронно)
  if (store.getters.isAuthenticated) {
    request.headers.set('Authorization', 'Bearer ' + store.state.token);
  }
  request.headers.set('Accept', 'application/json');

  // Установка X-Device-ID
  try {
    request.headers.set('X-Device-ID', DeviceFingerprint.generateIdSync());
  } catch (e) {
    request.headers.set('X-Device-ID', /*'fallback-id'*/ 'null');
  }

  // Добавляем заголовок, только если visitorId уже определен
  if (visitorId) {
    request.headers.set('X-Fingerprint-ID', visitorId);
  }

  // Прикрепление ответов капчи из локального кэша
  try {
    var pendingStr = localStorage.getItem('pending_captcha');
    if (pendingStr) {
      var pending = JSON.parse(pendingStr);
      if (pending && pending.value) {
        request.headers.set('X-Captcha-Id', pending.id);
        request.headers.set('X-Captcha-Value', pending.value);
      }
    }
  } catch (e) {
    localStorage.removeItem('pending_captcha');
  }

  // 2. Обработка ответа
  next(function(response) {
    if (response.ok) {
      localStorage.removeItem('pending_captcha');
      return response;
    }

    // А) Перехват капчи (Статус 423)
    if (response.status === 423) {
      var serverData = response.body;
      if (serverData && serverData.captcha) {
        localStorage.setItem('pending_captcha', JSON.stringify({
          id: serverData.captcha.captchaId,
          value: ''
        }));

        // СОЗДАЕМ ЧЕСТНЫЙ ПРОМИС ОЖИДАНИЯ КАПЧИ
        var captchaPromise = new Promise(function(resolveOuter, rejectOuter) {
          Vue.prototype.$captchaBus.$emit('show-captcha', {
            captcha: serverData.captcha,
            onResolve: function(userValue) {
              try {
                var pending = JSON.parse(localStorage.getItem('pending_captcha') || '{}');
                pending.value = userValue;
                localStorage.setItem('pending_captcha', JSON.stringify(pending));
                
                request.headers.set('X-Captcha-Value', userValue);
                request.headers.set('X-Captcha-Id', pending.id);
              } catch (e) {}

              // Помечаем запрос как повторный
              request.isRetry = true;

              // Выполняем повторный запрос (POST 200)
              Vue.http(request).then(function(retryResponse) {
                // Разрешаем наш промис полноценным, на 100% заполненным ответом
                resolveOuter(retryResponse);
              }).catch(function(err) {
                rejectOuter(err);
              });
            }
          });
        });

        // КРИТИЧЕСКИЙ ШАГ: Подменяем встроенные методы then и catch у текущего объекта ответа!
        // Теперь, когда ваш компонент вызовет .then() после registerClick, он подпишется 
        // на НАШ captchaPromise, который вернет данные только ПОСЛЕ ввода капчи.
        response.then = function(onFulfilled, onRejected) {
          return captchaPromise.then(onFulfilled, onRejected);
        };
        response.catch = function(onRejected) {
          return captchaPromise.catch(onRejected);
        };
        
        // Перезаписываем метод промиса для старых версий vue-resource
        response.promise = captchaPromise; 
        return response;
      }
    }

    // Б) Ваша исходная логика обработки ошибок
    if (response.status === 401) {
      // нужно, если не настроен функционал обновления токена
      // store.dispatch('logout');

      // Если этот запрос уже является запросом на обновление токена, 
      // значит RefreshToken тоже просрочен — принудительно разлогиниваем.
      if (request.url.includes(`${host.IdentityServiceApi}/RefreshToken`)) {
        store.dispatch('logout');
        return;
      }

      // Если процесс обновления токена уже запущен другим запросом
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
        .then((token) => {
          // Когда токен обновится, подставляем его в упавший запрос и повторяем
          // request.headers.set('Authorization', `Bearer ${token}`);
          request.headers.set('Authorization', 'Bearer ' + store.state.token);
          return Vue.http(request).then(resolve);
        })
        .catch((err) => {
          return Promise.reject(err);
        });
      }

      // Это первый запрос, поймавший 401. Запускаем процесс обновления.
      isRefreshing = true;

      return new Promise((resolve, reject) => {
        // Вызываем экшен обновления токенов из вашего Vuex Store
        // Он должен отправить POST на бэкенд, сохранить новые токены в store/localStorage
        store.dispatch('refreshToken')
          .then((newAccessToken) => {
            // Успех! Обновляем заголовок текущего запроса
            request.headers.set('Authorization', `Bearer ${newAccessToken}`);
            
            // Пропускаем вперед все остальные запросы из очереди
            processQueue(null, newAccessToken);
            
            // Повторно выполняем текущий запрос и возвращаем его результат в конвейер Vue
            Vue.http(request).then(resolve);
          })
          .catch((err) => {
            // Ошибка обновления (рефреш просрочен или заблокирован по SecurityStamp)
            processQueue(err, null);
            store.dispatch('logout');
            reject(err);
          })
          .finally(() => {
            isRefreshing = false;
          });
      });
      

    } else if (response.status === 403) {
      // toastr.error('Нет доступа');
    } else if (response.status >= 400) {
      if (response.body && response.body.message) {
        console.log(response.status + ': ' + response.body.message);
      } else {
        console.log(response.status + ': No response or server connection');
      }
    }
  });
});

Vue.filter('formatMsecToSecDuration', function (value) {
  if (value === null || value === undefined || value === '' || value === 0) return '0 sec';
  return (value / 1000.0).toFixed(2) + ' sec';
})

Vue.filter('formatSecToTimeDuration', function (value) {
  if (value === null || value === undefined || value === '' || value === 0) return '';
  const duration = {
    days: Math.floor(value / 86400),
    hours: Math.floor(value / 3600),
    minutes: Math.floor((value % 3600) / 60),
    seconds: value % 60
  };
  const digitalFormatter = new Intl.DurationFormat('ru-RU', { style: 'short' });
  return digitalFormatter.format(duration);
})

Vue.filter('formatSecToDaysHhMmSs', function (value) {
  if (!value || value === '') return '';
  const seconds = Math.floor(Number(value));
  if (isNaN(seconds)) return '';
  // Calculate days, hours, minutes, and remaining seconds
  const hours = Math.floor((seconds % (3600 * 24)) / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60)
  const duration = {
    days: Math.floor(seconds / (3600 * 24))
  };
  const digitalFormatter = new Intl.DurationFormat('ru-RU', { style: 'long' });
  return digitalFormatter.format(duration) + ' ' +
    Math.round(hours).toString().padStart(2, '0') + ':' +
    Math.round(minutes).toString().padStart(2, '0') + ':' +
    Math.round(secs).toString().padStart(2, '0');
})

Vue.filter('humanFileSize', function (valueInBytes) {
  if (valueInBytes === null || valueInBytes === undefined || valueInBytes === '') return '';
  let suffix;
  let readable = 0;
  const value = valueInBytes < 0 ? -valueInBytes : valueInBytes;
  if (value >= 0xFA0000000000000 /*0x1000000000000000*/) {
    suffix = "EiB";
    readable = value / 0x1000000000000000;
  } else
  if (value >= 0x3E80000000000 /*0x4000000000000*/) {
    suffix = "PiB";
    readable = value / 0x4000000000000;
  } else
  if (value >= 0xFA00000000 /*0x10000000000*/) {
    suffix = "TiB";
    readable = value / 0x10000000000;
  } else
  if (value >= 0x3E800000 /*0x40000000*/) {
    suffix = "GiB";
    readable = value / 0x40000000;
  } else
  if (value >= 0xFA000 /*0x100000*/) {
    suffix = "MiB";
    readable = value / 0x100000;
  } else
  if (value >= 0x400) {
    suffix = "KiB";
    readable = value / 1024;
  } else {
    return `0 B`;
  }
  const roundedValue = readable.toFixed(0);
  return roundedValue <= 99 ? `${readable.toFixed(1)} ${suffix}` : `${roundedValue} ${suffix}`;
  // return `${readable.toFixed(0)} ${suffix}`;
})

Vue.filter('formatDate', function (value) {
  if (!value) return '';
  return new Date(value.replace(/Z+$/, '') + 'Z').toLocaleDateString();
})

Vue.filter('formatDateForInput', function (value) {
  if (!value) return '';
  return new Date(value.replace(/Z+$/, '') + 'Z').toISOString().split('T')[0];
})

Vue.filter('formatDateTime', function (value) {
  if (!value || !value.length) return '';
  const dateTime = new Date(value.replace(/Z+$/, '') + 'Z');
  return `${new Date(dateTime).toLocaleDateString()} ${dateTime.toLocaleTimeString()}`;
})

Vue.filter('formatDateTimeOffset', function (dateString) {
  if (!dateString) return "";
  const date = new Date(dateString);
  
  // Локальное форматирование (автоматически подстроится под язык пользователя)
  return date.toLocaleString("ru-RU", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  });
})

Vue.filter('formatDateOnlyOffset', function (dateString) {
  if (!dateString) return "";
  const date = new Date(dateString);
  
  // Локальное форматирование (автоматически подстроится под язык пользователя)
  return date.toLocaleString("ru-RU", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
})

const formatDateTimeLongOptions = {
  year: "numeric",
  month: "long",
  day: "numeric",
  hour: "numeric",
  minute: "numeric"
};
Vue.filter('formatDateTimeMsk', function (value) {
  if (!value) return '';
  const dateTime = new Date(value.toString().replace(/Z+$/, '') + 'Z');
  return new Date(dateTime).toLocaleString("ru-RU", formatDateTimeLongOptions) + ' (MSK)';
})


Vue.filter('shortTime', function (value) {
  if (!value) return '';
  const [hours, minutes] = value.split(':');
  return `${Number(hours)}:${minutes}`;
});

FingerprintJS.load()
  .then(fp => fp.get())
  .then(result => {
    visitorId = result.visitorId;
    // Запуск Vue только после того, как visitorId гарантированно получен
    new Vue({
      router,
      store,
      render: function (h) { return h(App) }
    }).$mount('#app');
});